// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__398Gu","label":"Section_label__30Xgi","contentWrap":"Section_contentWrap__2Jg6T","footer":"Section_footer__W0ASU","footerInner":"Section_footerInner__He6T3"};